export enum Frequency {
  Hourly,
  Daily,
  Monthly,
}
